import * as React from "react"
const ElbetLogoSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    width={1889.76}
    height={453.543}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19685 4724"
    className={props.className}
    {...props}
  >
    <defs>
      <linearGradient
        id="id0"
        x1={16070.3}
        x2={16070.3}
        y1={4251.52}
        y2={426.157}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopOpacity: 1,
            stopColor: "#077837",
          }}
        />
        <stop
          offset={0.702}
          style={{
            stopOpacity: 1,
            stopColor: "#12903f",
          }}
        />
        <stop
          offset={1}
          style={{
            stopOpacity: 1,
            stopColor: "#1da848",
          }}
        />
      </linearGradient>
      <linearGradient
        id="id1"
        x1={10826.2}
        x2={10826.2}
        y1={4251.52}
        y2={426.154}
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopOpacity: 1,
            stopColor: "#ad1a1f",
          }}
        />
        <stop
          offset={0.702}
          style={{
            stopOpacity: 1,
            stopColor: "#cc1a20",
          }}
        />
        <stop
          offset={1}
          style={{
            stopOpacity: 1,
            stopColor: "#ec1a22",
          }}
        />
      </linearGradient>
      <linearGradient
        xlinkHref="#id0"
        id="id2"
        x1={13022.7}
        x2={13022.7}
        y1={4251.52}
        y2={426.154}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id0"
        id="id3"
        x1={18491.3}
        x2={18491.3}
        y1={4251.52}
        y2={426.154}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id4"
        x1={8691.01}
        x2={8691.01}
        y1={4251.52}
        y2={426.157}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id5"
        x1={1956.46}
        x2={2007.54}
        y1={5542.52}
        y2={937.02}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id6"
        x1={5011.8}
        x2={4051.67}
        y1={4546.68}
        y2={1498.52}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id7"
        x1={3706.5}
        x2={5810.54}
        y1={-799.354}
        y2={3191.73}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id8"
        x1={8889.28}
        x2={5955.7}
        y1={5375.57}
        y2={2434.88}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id9"
        x1={-391.579}
        x2={2153.23}
        y1={-597.654}
        y2={3123.6}
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#id1"
        id="id10"
        x1={4654.54}
        x2={-830.634}
        y1={3395.93}
        y2={-900.035}
        gradientUnits="userSpaceOnUse"
      />
      <style>
        {
          ".fil2,.fil3,.fil5{fill:#fff;fill-rule:nonzero}.fil2,.fil5{fill-opacity:.901961}.fil5{fill-opacity:.94902}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_690433912">
        <path
          d="M373 1427 259 3201l2024-756 39-1922z"
          style={{
            fill: "url(#id9)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="m259 3201 1540 1007 1904-542-1420-1221z"
          style={{
            fill: "url(#id5)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M2132 3870c5-57-85-111-201-121-116-11-214 27-219 84s85 111 201 121c116 11 214-27 219-84zM2269 3425c6-63-92-122-218-133-125-11-232 30-237 92-6 63 92 122 218 133 125 11 232-30 237-92zM1319 3306c6-62-91-123-216-135-126-13-233 27-239 89s90 123 216 135c125 13 232-27 239-89zM3237 3540c2-63-99-118-227-123-127-5-232 42-235 105-2 63 99 118 227 123 127 5 232-42 235-105zM2425 2918c6-71-97-137-230-149s-246 36-252 106c-6 71 97 137 230 149s245-36 252-106z"
          className="fil2"
        />
        <path
          d="M837 2458c-59-55-175-27-261 64-86 90-108 208-50 263s175 27 260-63c86-91 109-209 51-264zM875 1938c-58-54-173-26-259 64-86 91-108 208-51 262 58 55 173 26 259-64s108-207 51-262zM910 1440c-55-52-166-24-247 62-82 86-104 198-49 250s166 25 247-61c82-87 104-199 49-251zM2035 1990c-60-64-190-40-289 53-99 94-131 221-71 285s189 40 289-53c99-93 131-221 71-285zM2053 1448c-58-63-185-40-282 52-97 91-128 216-69 278 59 63 185 39 282-52s128-216 69-278zM2071 920c-54-58-176-30-273 61-96 91-131 211-77 268 54 58 176 31 273-60s131-212 77-269z"
          className="fil3"
        />
        <path
          d="m2322 523 1082 1256 299 1887-1420-1221z"
          style={{
            fill: "url(#id10)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M3426 3137c37-13 33-118-9-234s-106-200-143-186c-37 13-33 118 9 234s106 200 143 186zM3065 2297c38-15 30-123-17-240-48-118-117-201-154-186-38 15-30 123 18 240 47 118 116 201 153 186zM2699 1426c37-17 26-120-25-229-51-110-121-185-158-168s-25 120 25 229c51 110 122 185 158 168z"
          className="fil5"
        />
        <path
          d="m3404 1779-453-530-338 490 236 1192 854 735z"
          style={{
            fill: "#070707",
            fillRule: "nonzero",
            fillOpacity: 0.2,
          }}
        />
        <path
          d="m3280 1846 2353 547 869-1522-2312-369z"
          style={{
            fill: "url(#id7)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="m3280 1846 370 1835 2141 542-158-1830z"
          style={{
            fill: "url(#id6)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="m6502 871-42 1984-669 1368-158-1830z"
          style={{
            fill: "url(#id8)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M4042 2470c43-71-20-189-141-262-120-73-253-74-297-2-43 71 20 189 141 262 120 73 253 74 297 2zM5459 2824c46-76-18-200-143-275-125-76-264-75-310 1s18 200 143 275c125 76 264 76 310-1zM4222 3495c42-67-18-179-132-248-115-69-241-70-282-2s19 179 133 248c115 69 240 70 281 2zM5569 3857c42-71-19-186-138-258-118-71-249-72-292-2-42 70 20 185 138 257 119 72 249 73 292 3zM4211 1596c-4-83-113-145-244-139s-234 78-231 160c4 82 113 144 244 139 131-6 235-78 231-160zM4450 1200c-4-79-109-138-234-132-126 5-225 74-221 153 3 79 108 138 234 133 125-6 224-75 221-154zM4683 817c-4-76-104-133-225-127-121 5-216 71-212 147 3 76 104 133 224 127 121-5 216-71 213-147zM5648 1889c-1-88-120-159-266-158-146 2-264 74-263 163 0 88 119 158 265 157s264-74 264-162zM5891 1462c-4-85-124-148-267-142-144 7-257 80-253 165 4 84 123 148 267 141 143-6 256-80 253-164zM6114 1047c-3-80-117-139-254-133s-245 75-242 155c4 80 118 139 255 133s245-75 241-155zM5958 2563c22-137 10-253-28-259-38-7-87 99-110 236-22 137-10 253 28 259 38 7 87-99 110-236zM6195 2665c22-122 15-224-15-230-31-5-73 89-95 210-21 121-14 224 16 229 30 6 72-88 94-209zM6396 1661c22-138 16-254-14-259-31-5-74 103-96 241-23 138-17 254 14 259 30 5 73-103 96-241zM6008 3560c25-112 22-208-6-214-29-6-72 80-97 192s-22 207 7 214c28 6 71-80 96-192zM6384 2742c22-109 21-201-1-205-23-5-59 80-81 188-21 109-21 201 2 205 23 5 59-80 80-188z"
          className="fil3"
        />
        <path
          d="M8600 4233c-805 0-1267-450-1267-1233 0-449 164-899 452-1234 315-369 757-572 1243-572 611 0 1021 354 1021 881 0 669-561 995-1716 995-45 0-91-1-138-2 5 78 34 183 81 250 105 138 288 212 529 212 285 0 544-59 791-179l34-17 64 665-16 8c-400 204-887 226-1078 226zm-294-1833c315 0 540-25 686-77 146-53 214-129 214-242 0-135-109-219-284-219-348 0-568 265-639 538h23z"
          style={{
            fill: "url(#id4)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="m10022 4174 702-3640 907-48-712 3688z"
          style={{
            fill: "url(#id1)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M15980 4233c-806 0-1268-450-1268-1233 0-449 165-899 452-1234 316-369 757-572 1243-572 611 0 1022 354 1022 881 0 669-562 995-1716 995-45 0-92-1-139-2 6 78 34 183 82 250 105 138 288 212 528 212 285 0 544-59 791-179l34-17 64 665-16 8c-400 204-887 226-1077 226zm-295-1833c316 0 540-25 686-77 146-53 214-129 214-242 0-135-108-219-283-219-348 0-569 265-640 538h23z"
          style={{
            fill: "url(#id0)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M12584 4238c-674 0-1046-294-1046-828 0-187 33-371 65-527l450-2349 904-48-196 1064c218-227 525-356 853-356 617 0 893 513 893 1022 0 500-172 998-472 1364-245 300-697 658-1451 658zm638-2312c-306 0-584 323-677 787l-53 234c-2 21-6 45-9 69-12 74-24 151-19 240 5 185 113 291 295 291 449 0 811-632 811-1156 0-291-130-465-348-465z"
          style={{
            fill: "url(#id2)",
            fillRule: "nonzero",
          }}
        />
        <path
          d="M18313 4238c-482 0-770-239-770-641 0-158 17-319 59-537l216-1111 133-691 143-731 883-41-146 772h609l-133 691h-609l-189 951c-18 86-47 248-47 358 0 147 66 213 214 213 77 0 156 0 230-11l36-6-108 713-14 5c-118 46-339 66-507 66z"
          style={{
            fill: "url(#id3)",
            fillRule: "nonzero",
          }}
        />
      </g>
    </g>
  </svg>
)
export default ElbetLogoSvg
